import React, { Component } from 'react';
import AoVivoMain from '../../components/aovivo';
import DynamicTitle from '../../common/DynamicTitle/DynamicTitle';
import { fetchLastPlayedSongsIfNeeded } from '../../components/aovivo/actions/LastPlayedSongsAction';
import { fetchAovivoNewsIfNeeded } from '../../components/aovivo/actions/AovivoNewsAction';
import { getNewsDataIfNeeded } from '../../components/news/actions/NewsActions';
import { fetchAlbumSlidesIfNeeded } from '../../components/artists/actions/AlbumsSliderActions';
import NewsAoVivoMostReadContainer from '../../components/aovivo/containers/NewsAoVivoMostReadContainer';

const headerTags = {
    title: 'Ouça a melhor rádio FM online do Brasil',
    meta:
        {
            description: 'Quer ouvir música internacional de qualidade? Sintonize na Antena 1, a melhor rádio FM online do Brasil.',
            keywords: 'rádio online, ouvir rádio online, aovivo, play, player, música, álbuns, capas, música anos 60, música anos 80, música anos 90, música anos 2000, sucessos, músicas antigas, músicas clássicas, música romântica, últimas músicas tocadas, clássicos, lançamentos, montagens, letra da música, lady gaga, mariah carey, ed sheeran, kendrick lamar, katy perry, camila cabello, the weeknd, imagine dragons, dua lipa, sam smith, taylor swift, arctic monkeys, florence + the machine, jennifer lopez, celine dion, james bay, bee gees, duran duran, a ha, abba, radiohead, harry styles, lorde, laura pausini, andrea bocelli, pink floyd, spice girls, backstreet boys, p!nk, britney spears, shakira, justin timberlake, bruno mars, charlie puth, adele, beyoncé, bob marley, sia, michael jackson, rock, pop, música disco',
            'og:title': 'Ouvir rádio online - O melhor da música internacional | Antena 1',
            'og:description': 'Os grandes clássicos das décadas de 70, 80, 90 e os melhores lançamentos da música internacional você só escuta na rádio Antena 1, a número um em música!',
            'og:image': 'https://a1media.antena1.com.br/image/share/ao-vivo.png',
        },
};

class AoVivo extends Component {
    static fetchData(store) {
        const myPromises = [
            // Note: the getCurrentSongInfo data will NOT be prefetched, as this information should not be cached. (We currently have a cache of 60 seconds for all pages...)
            // ANd thus it is not possible to prefecth the artist bio :/
            store.dispatch(fetchLastPlayedSongsIfNeeded()), // note: this will get the song history for the default stream id 'antena_1' (set in the lastPlayedSongsActions)
            store.dispatch(fetchAovivoNewsIfNeeded(12)),
            store.dispatch(getNewsDataIfNeeded(10, 0)), // fetching always the desktop number of news, as we do not know if the user is on mobile or desktop, while on the server
            store.dispatch(fetchAlbumSlidesIfNeeded(20)),
        ];

        return Promise.all(myPromises);
    }

    render() {
        return (
            <div className="pageWrapper">
                <div className="tw-container tw-mx-auto tw-px-5">
                    <DynamicTitle defaultTags={headerTags} />
                    <AoVivoMain />

                </div>
                <NewsAoVivoMostReadContainer />
            </div>
        );
    }
}

export default AoVivo;
